<template>
  <div class="tabs-navigation">
    <div
      v-for="(tab, index) in tabs"
      :key="index"
      class="tab-navigation"
      :class="{ current: state.current === index }"
      v-text="tab"
      @click="changeTab(index)"
    />
  </div>
</template>

<script setup>
import { reactive } from "vue";

const emits = defineEmits(["changeTab"]);


const props = defineProps({
  tabs: {
    type: Array,
    required: true,
  },
  currentTab: {
    type: Number,
    default: 0,
  },
});

const state = reactive({
  current: props.currentTab,
});

function changeTab(index) {
  state.current = index;
  emits("changeTab", index);
}
</script>
